// @ts-nocheck
import * as Types from '../../@types/apiql.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TCreateProfileMutationVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']>;
  imageUrl?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type TCreateProfileMutation = { __typename?: 'Mutation', createProfile?: { __typename?: 'CreateProfilePayload', id: string, name?: string | null, imageUrl?: string | null, createdAt: any, lastUpdatedAt: any, clientMutationId?: string | null } | null };


export const CreateProfileDocument = gql`
    mutation CreateProfile($name: String, $imageUrl: String) {
  createProfile(input: {name: $name, imageUrl: $imageUrl, clientMutationId: ""}) {
    id
    name
    imageUrl
    createdAt
    lastUpdatedAt
    clientMutationId
  }
}
    `;
export type TCreateProfileMutationFn = Apollo.MutationFunction<TCreateProfileMutation, TCreateProfileMutationVariables>;

/**
 * __useCreateProfileMutation__
 *
 * To run a mutation, you first call `useCreateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProfileMutation, { data, loading, error }] = useCreateProfileMutation({
 *   variables: {
 *      name: // value for 'name'
 *      imageUrl: // value for 'imageUrl'
 *   },
 * });
 */
export function useCreateProfileMutation(baseOptions?: Apollo.MutationHookOptions<TCreateProfileMutation, TCreateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TCreateProfileMutation, TCreateProfileMutationVariables>(CreateProfileDocument, options);
      }
export type CreateProfileMutationHookResult = ReturnType<typeof useCreateProfileMutation>;
export type CreateProfileMutationResult = Apollo.MutationResult<TCreateProfileMutation>;
export type CreateProfileMutationOptions = Apollo.BaseMutationOptions<TCreateProfileMutation, TCreateProfileMutationVariables>;